<template>
  <div class="container">
    <div class="containerBg">
      <div class="titleBg">
        <div class="title">
          <router-link :to="{path:'/'}"><img :src="url+'/img/jiagong/sy.png'" class="return" /></router-link>
          <img :src="url+'/img/jiagong/fh.png'" class="return" @click="clickReturn" />
          <img :src="url+'/img/zhibo/gx.png'" class="guang1" />
          <img :src="url+'/img/zhibo/gx.png'" class="guang2" /> 
        </div>
      </div>
      <div class="content">
        <!-- 左侧 -->
        <!-- <div class="left animate__animated animate__slideInLeft">
          <div class="leftNavBg" :class="curNav==index ? 'leftNavBgCur':''" v-for="(item,index) in leftNav" :key="index"><router-link :to="{path:item.path}"><div class="leftNavItem">{{item.name}}</div></router-link></div>
        </div> -->
         <!--中间地图  -->
        <div class="center">
          <div class="centerBg1"></div>
          <div class="mapIcon1">
            <img :src="url+'/img/jiagong/mapIcon3.gif'" class="animate__animated animate__bounce"  />
            <router-link :to="{path:'/chejian'}"><span class="span">车间详情</span></router-link>
            <router-link :to="{path:'/chejian'}">
            <div class="centerInfo animate__animated " :class="showDiv?'animate__bounceIn' :'animate__bounceOut'"  v-if="showDiv">
              <h3>车间详情</h3>
              <div class="jkXq">
                <div class="jkItemA" v-for="(item,index) in jiankongList" :key="index">
                  <div class="jkItemB" v-for="(item0,index0) in item" :key="index0">
                    <span>{{item0.name}}：</span><span>{{item0.value}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <div class="mapIcon2">
            <img :src="url+'/img/jiagong/mapIcon3.gif'" class="animate__animated animate__bounce"  />
            <router-link :to="{path:'/kshyqjk'}"><span class="span">监控详情</span></router-link>
            <router-link :to="{path:'/kshyqjk'}">
            <div class="centerInfo animate__animated" :class="!showDiv?'animate__bounceIn' :'animate__bounceOut'" v-if="!showDiv">
              <h3>监控详情</h3>
              <div class="jkXq">
                <div class="jkItemA" v-for="(item,index) in jiankongList" :key="index">
                  <div class="jkItemB" v-for="(item0,index0) in item" :key="index0">
                    <span>{{item0.name}}：</span><span>{{item0.value}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <!-- <div class="mapIcon3">
            <img :src="url+/img/jiagong/mapIcon3.gif" />
          </div> -->
        </div>
        
        <!-- 右侧 -->
        <div class="right animate__animated animate__slideInRight">
          <div class="rightBox rightBox1">
            <div class="rightTitle">
              <div class="titleCon">园区管理</div>
              <div class="music"><span></span> <span></span> <span></span></div>
            </div>
            <div class="rightContent1">
              <div class="rightContent1Item" v-for="(item,index) in rightData1" :key="index" @mouseenter="mouseenter(index)" 
        @mouseleave="mouseleave(index)">
                <div class="leftBox"><div class="leftIcon"></div><img :src="item.icon" /></div>
                <div class="rightInfo">
                  <div class="rightInfo1 animate__animated" :class="item.animateShow?' animate__fadeOutRight':'animate__fadeInLeft'"  v-if="!item.animateShow"><div class="txtStyle">{{item.title}}</div></div>
                  <div class="rightInfo1Hover animate__animated" :class="item.animateShow?'animate__fadeInLeft':'animate__fadeOutRight'"  v-if="item.animateShow"><div class="txtStyle">{{item.title}}</div></div>
                  <div class="rightInfo2">
                    <span>{{item.name}}</span>
                    <span class="animate__animated" :class="item.animateShow?' animate__fadeOutUp':'animate__fadeInUp'"  v-if="!item.animateShow">{{item.value}}</span>
                    <span class="animate__animated" :class="item.animateShow?' animate__fadeInUp':'animate__fadeOutUp'"  v-if="item.animateShow">{{item.value}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rightBox rightBox2">
            <div class="rightTitle"><div class="titleCon">加工统计</div><div class="music"><span></span> <span></span> <span></span></div></div>
            <div class="rightContent2"><RightBar /></div>
          </div>
          <div class="rightBox rightBox3">
            <div class="rightTitle"><div class="titleCon">近七天加工统计</div><div class="music"><span></span> <span></span> <span></span></div></div>
            <div class="rightContent3"><RightLine /></div>
          </div>
        </div>
      </div>
    </div>
      
  </div>
  <footer1 />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';
import { useRouter } from 'vue-router'

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// import waterimg from "@/assets/img/xaiofei/fk.png"


import RightBar from "../components/jiagong/RightBar"
import RightLine from "../components/jiagong/RightLine"
import footer1 from "../components/footer.vue";


export default {
  name: "Home",
  setup() {
    const { proxy } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      url:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      currentTime: "",
      leftNav:[{name:"加工",path:"/jiagong"},{name:"车间",path:"/chejian"},{name:"监控",path:"/kshyqjk"}],
      curNav:0,
      rightData1:[
        {title:"监控情况",name:"异常占比",value:"0.03%",icon:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/tc.png",animateShow:false},
        {title:"停车情况",name:"停车占比",value:"73.2%",icon:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/jk.png",animateShow:false}
      ],
      animateShow:false,
      jiankongList:[
        [{name:"监控位置",value:"A1区主楼"},{name:"异常位置",value:"未发现异常"},{name:"安保位置",value:"A区"}],
        [{name:"所属区域",value:"上蔡县"},{name:"具体名称",value:"状元红园区"},{name:"坐在地址",value:"上蔡XXXX街道XX路"}],
        ],
      showDiv:true
    });
    onMounted(() => {
        // clearInterval(timer.value);
        // timer.value = setInterval(() => {
        //   state.currentTime = proxy.$utils.getCurrentTime();
        // }, 1000);
        // console.log(state.currentTime)
        setInterval(() => {
            state.showDiv = !state.showDiv
          }, 6000);
    })
    onUnmounted(() => {
      // 清理资源
      
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    })
    // 返回上一页
    function clickReturn(){
      router.go(-1);
    }
    // 鼠标经过
    function mouseenter(index){
      // let rightData1 = 
      state.rightData1[index].animateShow = true
    }
    // 鼠标离开
    function mouseleave(index){
      // let rightData1 = 
      state.rightData1[index].animateShow = false
    }
    return {
      ...toRefs(state),
      close,
      mouseenter,
      mouseleave,
      clickReturn
      
    };
  },
  components: {
      RightBar,
      RightLine,
      footer1
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/font/DS-DIGIT.TTF");
}
a{color: #fff;}
.container{
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  overflow: hidden;
  .containerBg{
    width: 100%;
    height: 100%;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/fc.png") no-repeat top center;
    background-size: 100% 100%;
    color: #fff;
    position: relative;
  }
  .titleBg{
   background: linear-gradient(to bottom,rgba(0,0,0,1)20%,rgba(0,0,0,0));
  }
  .title{
    position: relative;
    width: 100%;
    height: 95px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/bt.png") no-repeat top center;
    background-size: 100% 100%;
    color: #fff;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return{
      width: 68px;
      height: 23px;
      cursor: pointer;
      margin-right: 50px;
      margin-top: 16px;
      position: relative;
      z-index: 999;
    }
    .return:first-child{
      margin-left: 50px;
    }
    .guang1{
      position: absolute;
      top: -34px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -34px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1{
      0%{
        left: 0;
      }
      100%{
        left: 15%;
      }
    }
    @keyframes titleGuang2{
      0%{
        right: 0;
      }
      100%{
        right: 15%;
      }
    }
       
  }
  
  
  .content{
    width: 100%;
    height: calc(100% - 85px);
    display: flex;
    .left{
      // width: 127px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // padding-left: 50px;
      .leftNavBg{
        width: 127px;
        height: 39px;
        margin: 50px 0;
        cursor: pointer;
        .leftNavItem{
          width: 100px;
          height: 39px;
          background: linear-gradient(to right, rgba(0,169,134,1) , rgba(0,169,134,0), rgba(0,169,134,1));
          box-shadow: 3px 0px 7px 0px #000000;
          border-radius: 18px 18px 18px 18px;
          line-height: 39px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          font-style: italic;
          color: #fff;
          transition: all 0.5s ease-out;
          animation: daxiao 1s linear infinite;
        }
        a{
          text-decoration:none;
        }
      }
      .leftNavBg:hover,.leftNavBgCur{
        background: linear-gradient(to right, rgba(97,238,166,1) , rgba(97,238,166,0));
        .leftNavItem{
          background: linear-gradient(to right, rgba(97,238,166,1) , rgba(97,238,166,0), rgba(97,238,166,1));
          margin-left:35px;
        }
      }  
    }
    .center{
      flex: 1;
      margin: 0 20px;
      position: relative;
      .centerBg1{
        position: absolute;
        right: 4%;
        top: 37%;
        background: url('https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/jx.png');
        width: 347px;
        height: 173px;
      }
      .mapIcon1{
        position: absolute;
        top:15%;
        left: 25%;
        img{
          width: 50px;
        }
        .span{
          text-shadow:2px 2px 10px rgba(0, 0, 0, 1), ;
          position: absolute;
          top: 10px;
          left: 50px;
          width: 100px;
          font-size: 20px;
          text-align: left;
        }
      }
      .mapIcon2{
        position: absolute;
        top:34%;
        left: 59%;
        img{
          width: 50px;
        }
        .span{
          text-shadow:2px 2px 10px rgba(0, 0, 0, 1), ;
          position: absolute;
          top: 10px;
          left: 50px;
          width: 100px;
          font-size: 20px;
          text-align: left;
        }
      }
      .centerInfo{
          position: absolute;
          top: 100%;
          left: 50%;
          width: 389px;
          height: 208px;
          margin-left: -195px;
          background: rgba(0,0,0,.5);
          border-radius: 10px 10px 10px 10px;
          animation-delay: 1s;
          padding: 25px;
          box-sizing: border-box;
          h3{
            font-size: 14px;
            font-weight: bold;
            font-style: italic;
            text-align: left;
          }
          .jkXq{
            padding: 5px 0 10px;
            .jkItemA{
              border-bottom: 1px solid #A9A9A9;
              display: flex;
              flex-wrap: wrap;
              padding: 8px 0;
              .jkItemB{
                width: 50%;
                display: flex;
                font-size: 12px;
                line-height: 30px;
                span{
                  display: block;
                }
                span:nth-child(1){
                  color: #A8A8A8;
                }
              }
            }
            .jkItemA:nth-child(2){
                border-bottom: 0;
               .jkItemB:nth-child(3){
                width: 100%;
               } 
              }

          }
        }
    }
    .right{
      width: 697px;
      margin-top: 20px;
      margin-right: 30px;
      display: flex;
      flex-direction: column;
      .rightBox{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        .rightTitle{
          width: 100%;
          height: 40px;
          background: #00140E;
          position: relative;
          .titleCon{
            position: absolute;
            left: -15px;
            top: 0;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/btk.png") no-repeat top center;
            width: 216px;
            height: 64px;
            line-height: 60px;
            font-size: 18px;
            font-weight: bold;
            font-style: italic;
          }
        }
      }
      .rightBox1{
        height: 200px;
        .rightContent1{
          width: 100%;
          flex: 1;
          padding: 0 50px;
          box-sizing: border-box;
          background: rgba(0,0,0,0.5);
          border: 1px solid #002D20;
          border-top: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .rightContent1Item{
            display: flex;
            flex: 1;
            margin-right: 20px;
            cursor: pointer;
            .leftBox{
              width: 73px;
              height: 88px;
              position: relative;
              .leftIcon{
                width: 73px;
                height: 88px;
                background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/gq.png") no-repeat top left;
                margin-right: 20px;
                animation: rightDaxiao 1.2s ease-in-out infinite;
                // animation-delay: 5s;
                // animation-fill-mode: forwards;
              }
              img{
                position: absolute;
                top: 0;
                left: 0;
              }
            }
            
            .rightInfo{
              flex: 1;
              text-align: left;
              display: flex;
              flex-direction: column;
              justify-content: center;
              // align-items: center;
              .rightInfo1{
                width: 70%;
                height: 22px;
                background: linear-gradient(to right,rgba(132,201,114,0.5),rgba(132,201,114,0.2), rgba(0,0,0,0));
                line-height: 22px;
                font-size: 16px;
                color: #fff;
                line-height: 22px;
                margin-bottom:10px;
                padding-left:10px;
                font-style: italic;
                transition: all 0.5s ease-out;
                // animation: rightDaxiao1 1.2s linear infinite;
  
              }
              .rightInfo2{
                font-size: 20px;
                display: flex;
                // justify-content: space-between;
                span{
                  display: block;
                }
              }
              .rightInfo2 span:nth-child(1){
                margin-right: 20px;
                color: #D1D6DF;
              }
              .rightInfo2 span:nth-child(2){
                position: relative;
                display: inline-block;
                font-size: 20px;
                color: #A0F17C;
              }

            }
          }
          .rightContent1Item:hover{
            
            .leftIcon{
              background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/gqHover.png") no-repeat top left;
              animation: guangying .5s linear;
              animation-fill-mode: forwards;
            }
            .rightInfo1Hover{
                width: 70%;
                height: 22px;
                background: linear-gradient(to right,rgba(0,140,20,0.8),rgba(0,140,20,0.2), rgba(0,0,0,0));
               line-height: 22px;
                font-size: 16px;
                color: #fff;
                line-height: 22px;
                margin-bottom:10px;
                padding-left:10px;
                font-style: italic;
                transition: all 0.5s ease-out;
              .txtStyle{
                color: #fff;
                background: linear-gradient(to top, #00FF24, #FFFFFF);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
            .rightInfo2 span:nth-child(2){
              color: #008C21;
            }
          }
        }
      }
      .rightBox2{
        flex: 1;
        .rightContent2{
          width: 100%;
          flex: 1;
          background: rgba(0,0,0,.5);
          border: 1px solid #002D20;
          border-top: 0;
        }
      }
      .rightBox3{
        height: 280px;
        .rightContent3{
          width: 100%;
          flex: 1;
          background: rgba(0,0,0,.5);
          border: 1px solid #002D20;
          border-top: 0;
        }
      }
    }
    
  }
}
@keyframes line{
  0%{                     
      width: 0;
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    width: 96%;
  }
   100%{
     width: 0;
  }
} 
@keyframes bianda {
  0%{                     
       filter: drop-shadow(0 0 0 rgba(35, 151, 157, 1));
  } 
  50%{
     filter: drop-shadow(0 0 5px rgba(35, 151, 157, 1));
  }
   100%{
     filter: drop-shadow(0 0 0 rgba(35, 151, 157, 1));
  }
}
@keyframes daxiao {
  0%{                     
       transform: scale(0.96);
  } 
  50%{
    transform: scale(1);
  }
   100%{
    transform: scale(0.96);
  }
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(360deg);
  }
}
@keyframes rightDaxiao {    /*引用动画名称*/
  0%{                     
       transform: scale(0.96);
       transform: rotate(0);
  } 
  50%{
    transform: scale(1.1);
    transform: rotate(20deg);
  }
   100%{
    transform: scale(0.96);
    transform: rotate(0deg);
  }
}
@keyframes rightDaxiao1 {    /*引用动画名称*/
  0%{                     
       width: 0;
  } 
  50%{
    width: 70%;
  }
   100%{
    width: 0;
  }
}

</style>
